import { BackButton } from '@common/components/BackButton';
import { Title } from '@common/components/Title';
import { Background } from '@features/Collection';
import { Box, Flex, Grid, ScrollArea, Skeleton } from '@radix-ui/themes';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionsBlock } from '../components/ActionsBlock';
import { ClipPlayer } from '../components/ClipPlayer';
import { HistorySection } from '../components/HistorySection';
import { InfoSection } from '../components/InfoSection';
import { ProgramLink } from '../components/ProgramLink';
import { useSelectedClip } from '../hooks/useSelectedClipSelectors';

export const AssetDetailsPage = () => {
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    useTranslation();

    const { selectedClip, isLoading } = useSelectedClip();
    const { hasProxy } = selectedClip;

    return (
        <Background scrollRef={scrollContainerRef}>
            <ScrollArea ref={scrollContainerRef} type={'scroll'}>
                <Flex direction={'column'} gap={'6'} p={'5'} minHeight={'100%'}>
                    <Box>
                        <BackButton />
                    </Box>

                    <Flex direction={'column'} gap={'4'}>
                        <Title mb={'0'}>
                            <Skeleton loading={isLoading}>
                                {selectedClip.clipName}
                            </Skeleton>
                        </Title>
                        <ProgramLink />
                    </Flex>

                    <Box>
                        <Skeleton loading={isLoading}>
                            <ActionsBlock selectedClip={selectedClip} />
                        </Skeleton>
                    </Box>

                    <Grid
                        columns={{
                            initial: '1',
                            lg: '2',
                        }}
                        gap={'9'}
                        align={'start'}
                    >
                        <InfoSection />
                        {hasProxy && <ClipPlayer />}
                    </Grid>

                    <Box>
                        <HistorySection />
                    </Box>
                </Flex>
            </ScrollArea>
        </Background>
    );
};
